interface AvailabilitySlot {
    startAt: number;
}

const getMinAvailableStartAt = (
    availability: AvailabilitySlot[] = [],
) => availability.reduce<number | undefined>(
    (min, { startAt }) => (
        min === undefined || startAt < min
            ? startAt
            : min
    ),
    undefined,
);

export default getMinAvailableStartAt;
